import { useContext } from "react";
import { ApplicationContext } from "@/context/ApplicationContext";

export const useClientProfileToggle = () => {
  const { toggles, togglesLoading, togglesError } = useContext(ApplicationContext);
  const enabled = !togglesLoading && !togglesError && Boolean(toggles?.enable_client_profile_on_orders);

  return { enabled, togglesLoading, togglesError };
};
